function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6667 2.50004H14.8334V1.66671C14.8334 1.20837 14.4584 0.833374 14.0001 0.833374C13.5417 0.833374 13.1667 1.20837 13.1667 1.66671V2.50004H4.83342V1.66671C4.83342 1.20837 4.45841 0.833374 4.00008 0.833374C3.54175 0.833374 3.16675 1.20837 3.16675 1.66671V2.50004H2.33341C1.41675 2.50004 0.666748 3.25004 0.666748 4.16671V17.5C0.666748 18.4167 1.41675 19.1667 2.33341 19.1667H15.6667C16.5834 19.1667 17.3334 18.4167 17.3334 17.5V4.16671C17.3334 3.25004 16.5834 2.50004 15.6667 2.50004ZM14.8334 17.5H3.16675C2.70841 17.5 2.33341 17.125 2.33341 16.6667V6.66671H15.6667V16.6667C15.6667 17.125 15.2917 17.5 14.8334 17.5Z",
  fill: "#586071"
});

var SvgCalendarIcon = function SvgCalendarIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar_icon.765939a2.svg";
export { ForwardRef as ReactComponent };